import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#F8F9FA",
      paper: "#FFFFFF",
    },
    primary: {
      main: "#6366F1",
    },
    divider: "#E2E8F0",
    text: {
      primary: "#0F172A",
      secondary: "#64748B",
    },
  },

  shape: {
    borderRadius: 12,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F8F9FA",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid #E2E8F0",
          boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
          padding: "10px 18px",
        },
        containedPrimary: {
          background: "linear-gradient(135deg, #6366F1, #8B5CF6)",
          boxShadow: "0 4px 12px rgba(99,102,241,0.35)",
        },
        containedPrimaryHover: {
          background: "linear-gradient(135deg, #4F46E5, #7C3AED)",
        },
      },
    },
  },
});

export default theme;